import React from 'react';
import { RichText } from 'prismic-reactjs';
import htmlSerializer from "@utils/htmlSerializer/htmlSerializer";
import styles from "./textSection.module.scss";

const TextSection = ({ text }) => (
  <div className={styles.textSection}>
    <RichText render={text} htmlSerializer={htmlSerializer} />
  </div>
);

export default TextSection;
